import { render, staticRenderFns } from "./depositTotal.vue?vue&type=template&id=99ecf888&scoped=true"
import script from "./depositTotal.vue?vue&type=script&lang=ts"
export * from "./depositTotal.vue?vue&type=script&lang=ts"
import style0 from "./depositTotal.vue?vue&type=style&index=0&id=99ecf888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ecf888",
  null
  
)

export default component.exports